/* eslint-disable no-debugger */
import {
  removeEntity,
  _emailIsValid,
  _urlIsValid,
  getContentForComponent,
  convertDocumentContent,
} from "../../utils/documentUtils";
import { fillFormFieldInLayout } from "../../utils/quotationUtils";
import getEditorHTML from "../../components/RevvEditor/getEditorHtml";

export const prepareDocAnalysisData = analysis => {
  const docAnalysisData = [];
  analysis.forEach(item => {
    item.rules.forEach(rule => {
      const tempObj = {};
      const tempApprovers = [];
      const tempGrpApprovers = [];
      rule.action.data.levels.forEach(level => {
        if (level.approvers && level.approvers.length > 0) {
          tempApprovers.push(level.approvers);
        }
        if (level.group_approvers && level.group_approvers.length > 0) {
          tempGrpApprovers.push(level.group_approvers);
        }
      });
      tempObj.id = rule.id;
      tempObj.approvalType = rule.action.data.type;
      tempObj.approvers = tempApprovers.flat();
      tempObj.groupApprovers = tempGrpApprovers.flat();
      tempObj.triggeMessage = rule.action.trigger_message;
      docAnalysisData.push(tempObj);
    });
  });
  return docAnalysisData;
};

export const prepareDocApprovalStatusData = approvalStatus => {
  const approvalStatusData = [];
  const pendingApprovers = [];
  const allApprovers = [];
  if (approvalStatus) {
    approvalStatus.forEach(item => {
      const tempObj = {};
      tempObj.workflowID = item.id;
      tempObj.workflowStatus = item.status;
      tempObj.reasons = item.reason.split("\n");
      tempObj.name = item.trigger;
      if (item.levels[0].approvers) {
        tempObj.approvers = item.levels[0].approvers.map(i => {
          if (i.status === "PENDING") {
            pendingApprovers.push(i.id);
          }
          allApprovers.push(i.id);
          return i;
        });
      } else {
        tempObj.approvers = [];
      }
      approvalStatusData.push(tempObj);
    });
  }
  return { approvalStatusData, pendingApprovers, allApprovers };
};

export const prepareCollaboratorsData = approvals => {
  const collaboratorsData = [];
  if (approvals) {
    approvals.forEach(approval => {
      const tempObj = { approvers: [] };
      if (approval.type === "PARALLEL" || approval.type === "") {
        const tempAllApprovers = [];
        const tempApprovers = [];
        const tempGrpApprovers = [];
        approval.levels.forEach(level => {
          if (level.approvers && level.approvers.length > 0) {
            tempApprovers.push(level.approvers);
          }
          if (level.group_approvers && level.group_approvers.length > 0) {
            tempGrpApprovers.push(level.group_approvers);
          }
          tempAllApprovers.push(
            tempGrpApprovers.flat().concat(tempApprovers.flat()),
          );
        });
        tempObj.approvers = tempAllApprovers.flat();
      } else if (approval.type === "SEQUENTIAL") {
        const tempApprovers = [];
        approval.levels.forEach(level => {
          if (level.approvers && level.approvers.length > 0) {
            tempApprovers.push(level.approvers);
          }
          if (level.group_approvers && level.group_approvers.length > 0) {
            tempApprovers.push(level.group_approvers);
          }
        });
        tempObj.approvers = tempApprovers.flat();
      }

      tempObj.id = approval.id;
      tempObj.triggeMessage = approval.reason;
      tempObj.approvalType = approval.type;
      collaboratorsData.push(tempObj);
    });
  }
  return collaboratorsData;
};

export const removeEntityFromSection = (
  section,
  entityID,
  accept,
  mode = "DOCUMENT",
) => {
  const { data } = section;
  const updatedData = removeEntity(data, entityID, accept);
  const updatedHTML = getEditorHTML(updatedData, mode);
  return {
    ...section,
    data: updatedData,
    html: updatedHTML,
  };
};

export const validateDocForm = (form = [], components = {}) => {
  let isValid = true;
  if (form.length === 0) {
    return isValid;
  }

  // get all the dynamic field form
  const dynamicFieldForm = form.filter(
    f => f.type !== "CLAUSE" && f.occurrences.length > 0,
  );

  // check valid state for dynamic field
  for (let index = 0; index < dynamicFieldForm.length; index += 1) {
    const field = dynamicFieldForm[index];
    const value = field.value || (field.meta && field.meta.default);
    if (value === null || value === "" || value === undefined) {
      isValid = false;
      break;
    }
    if (field.type === "ADDRESS") {
      if (
        value.addressLineOne === "" ||
        value.city === "" ||
        value.state === "" ||
        value.zip === ""
      ) {
        isValid = false;
        break;
      }
    }
    if (field.type === "EMAIL" && !_emailIsValid(value)) {
      isValid = false;
      break;
    }
    if (field.type === "URL" && !_urlIsValid(value)) {
      isValid = false;
      break;
    }
    if (field.type === "PERCENT" && (value < 0 || value > 100)) {
      isValid = false;
      break;
    }
    if (field.type === "PHONE") {
      const re = /^[0-9\b]+$/;
      if (!re.test(value)) {
        isValid = false;
        break;
      }
    }
    if (field.type === "PERIOD" || field.type === "PERSON_NAME") {
      for (let i = 0; i < Object.values(value).length; i += 1) {
        const element = Object.values(value)[i];
        if (element === "" || element === null) {
          isValid = false;
          break;
        }
      }
    }
  }

  // check for all the clause options except for optional, everything should be field
  Object.keys(components).forEach(componentId => {
    const section = components[componentId].content;
    const { clauseOptions } = section;
    if (clauseOptions) {
      const { id, value } = clauseOptions;
      const clause = form.find(f => f.id === id);
      if (
        clause &&
        clause.meta &&
        clause.meta.subtype !== "optional" &&
        clause.meta.subtype !== "free_text"
      ) {
        if (
          clause.meta.subtype === "multi_select" &&
          value &&
          Array.isArray(value) &&
          value.length === 0
        ) {
          isValid = false;
        } else if (!value) {
          isValid = false;
        }
      }
    }
  });

  return isValid;
};

// putting this in actions file creates Dependency cycle as it is used in services file
export const updateDocSaveIndicator = val => dispatch => {
  dispatch({
    type: "UPDATE_DOC_SAVE_INDICATOR",
    payload: val,
  });
};

export const updateComponentsDBRowColIndexesAction =
  newComponents => dispatch => {
    dispatch({
      type: "UPDATE_COMPONENTS_DB_ROW_COL_INDEXES",
      payload: { newComponents },
    });
  };

export const getUpdatedFormFieldsWithField = (
  fieldsUsed,
  newFields,
  fillValue = true,
  allFieldsUsed,
) => {
  const updatedField = []; // last updated field since iterating over all
  const allUpdatedField = [];
  let tempField = {};
  let flag = false;
  const updatedFields = fieldsUsed.map(fu => {
    flag = false;
    newFields.forEach(newField => {
      // tempField = {};
      if (fu.id === newField.id) {
        flag = true;
        tempField = {
          ...fu,
          value: fillValue ? newField.value : fu.value,
          filler_type: newField.filler_type,
          // conditional_logic: { ...newField.conditional_logic },
        };
        if (newField.conditional_logic) {
          tempField.conditional_logic = { ...newField.conditional_logic };
        }
        updatedField.push(tempField);
      }
    });
    if (flag) return tempField;
    return fu;
  });
  // This is for fields in clause calculating all fields
  const allUpdatedFields = allFieldsUsed.map(fu => {
    flag = false;
    newFields.forEach(newField => {
      // tempField = {};
      if (fu.id === newField.id) {
        flag = true;
        tempField = {
          ...fu,
          value: fillValue ? newField.value : fu.value,
          filler_type: newField.filler_type,
          // conditional_logic: { ...newField.conditional_logic },
        };
        if (newField.conditional_logic) {
          // flag = true;
          tempField.conditional_logic = { ...newField.conditional_logic };
        }

        allUpdatedField.push(tempField);
      }
    });
    if (flag) return tempField;
    return fu;
  });
  return {
    updatedField,
    updatedFields,
    allUpdatedField,
    allUpdatedFields,
  };
};

export const getUpdatedFormFieldsWithFieldCatalog = (fieldsUsed, newFields) => {
  const completeField = [];
  let updatedField = {}; // last updated field since iterating over all
  const updatedFields = fieldsUsed.map(fu => {
    newFields.map(ca => {
      if (fu.id === ca.id) {
        updatedField = {
          ...fu,
          value: ca.value,
          filler_type: ca.filler_type,
        };
        completeField.push(updatedField);
      }
      return completeField;
    });
    return fu;
  });
  return {
    completeField,
    updatedFields,
  };
};
export const getUpdatedDynamicFieldsInSections = (
  components,
  documentType,
  currency,
  fieldsUsed,
  updatedField,
  allFieldsUsed,
  allUpdatedField,
) => {
  const updatedSection = [];
  Object.keys(components).forEach(key => {
    if (
      updatedField &&
      Array.isArray(updatedField) &&
      updatedField.length > 0
    ) {
      updatedField.forEach(field => {
        if (Array.isArray(field.occurrences) && field.occurrences.length > 0) {
          field.occurrences.forEach(df => {
            if (df.componentId === key)
              updatedSection.push(components[key].content);
          });
        }
      });
    }
  });
  // Calculating the occurences for fields in clause case
  Object.keys(components).forEach(key => {
    if (
      allUpdatedField &&
      Array.isArray(allUpdatedField) &&
      allUpdatedField.length > 0
    ) {
      allUpdatedField.forEach(field => {
        if (Array.isArray(field.occurrences) && field.occurrences.length > 0) {
          field.occurrences.forEach(df => {
            if (df.componentId === key)
              updatedSection.push(components[key].content);
          });
        }
      });
    }
  });
  const updatedComponents = updatedSection.map(section => {
    const newComponent = getContentForComponent(section, documentType);
    const sectionID = section.section_id || section.id;
    newComponent.id = sectionID;
    newComponent.section_id = sectionID;
    newComponent.section_type = section.type || section.section.section_type;
    newComponent.section_name = section.header || section.section_name;
    newComponent.source = "DRAFT-JS";
    return {
      content: newComponent,
      component_id: sectionID,
    };
  });
  const filledSection = [
    ...fillFormFieldInLayout(updatedComponents, allFieldsUsed, currency),
  ];
  // Sending all fields instead of fields used for fields in clause case
  const updatedSectionList = convertDocumentContent(
    filledSection,
    documentType,
    allFieldsUsed,
  );
  return updatedSectionList;
};

export const getUpdatedDynamicFieldsInSectionsForCatalog = (
  components,
  documentType,
  currency,
  fieldsUsed,
  updatedField,
) => {
  const updatedSection = [];
  Object.keys(components).forEach(key => {
    if (Array.isArray(updatedField) && updatedField.length > 0) {
      updatedField.forEach(df => {
        if (df.occurrences) {
          df.occurrences.forEach(dff => {
            if (dff.componentId === key)
              updatedSection.push(components[key].content);
          });
        }
      });
    }
  });
  const updatedComponents = updatedSection.map(section => {
    const newComponent = getContentForComponent(section, documentType);
    const sectionID = section.section_id || section.id;
    newComponent.id = sectionID;
    newComponent.section_id = sectionID;
    newComponent.section_type = section.type || section.section.section_type;
    newComponent.section_name = section.header || section.section_name;
    newComponent.source = "DRAFT-JS";
    return {
      content: newComponent,
      component_id: sectionID,
    };
  });
  const filledSection = [
    ...fillFormFieldInLayout(updatedComponents, fieldsUsed, currency),
  ];
  const updatedSectionList = convertDocumentContent(
    filledSection,
    documentType,
    fieldsUsed,
  );
  return updatedSectionList;
};

const TransformFieldValueStructure = {
  COMMON: ({ value }) => value,
  ADDRESS: ({ value }) => value,
  PERSON_NAME: ({ value }) => value,
  SINGLE_SELECT: ({ value }) => value,
  CHECKBOX: ({ value }) => value,
  RADIO: ({ value }) => value,
  EMAIL: ({ value }) => value,
  NUMBER: ({ value }) => value,
  DATE: ({ value, prevValue }) => ({ ...prevValue, val: value }),
  PERCENT: ({ value }) => value,
  AMOUNT: ({ value, prevValue }) => ({ ...prevValue, val: value }),
  COUNTRY: ({ value }) => value,
  US_STATES: ({ value }) => value,
  PHONE: ({ value }) => value,
  RATE: ({ value }) => value,
  PERIOD: ({ value }) => value,
  SINGLE_LINE_TEXT: ({ value }) => value,
  MULTI_LINE_TEXT: ({ value }) => value,
  URL: ({ value }) => value,
};

export const changeFormFieldsValue = (id, value, fieldsUsed, allFieldsUsed) => {
  let updatedField = {}; // last updated field since iterating over all
  let allUpdatedField = {};
  const updatedFields = fieldsUsed.map(fu => {
    if (fu.id === id) {
      updatedField = {
        ...fu,
        value: TransformFieldValueStructure[fu.type]
          ? TransformFieldValueStructure[fu.type]({
              value,
              prevValue: fu.value,
            })
          : value,
      };
      return updatedField;
    }
    return fu;
  });
  const allUpdatedFields = allFieldsUsed.map(fu => {
    if (fu.id === id) {
      allUpdatedField = {
        ...fu,
        value: TransformFieldValueStructure[fu.type]
          ? TransformFieldValueStructure[fu.type]({
              value,
              prevValue: fu.value,
            })
          : value,
      };
      return allUpdatedField;
    }
    return fu;
  });
  return {
    updatedField,
    updatedFields,
    allUpdatedField,
    allUpdatedFields,
  };
};

export const getSignerIdentityTags = signerTags => {
  const signerIdentityTags = {};
  signerTags.forEach(tag => {
    const { signer_identity_id } = tag;
    if (signer_identity_id in signerIdentityTags) {
      signerIdentityTags[signer_identity_id].push(tag);
    } else {
      signerIdentityTags[signer_identity_id] = [tag];
    }
  });
  return signerIdentityTags;
};
